import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "show", "transactions", "list", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--cards--bills--dashboard`
  }

  doBillsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-2 pr-1" data-${this.controllerName}-target="list" data-controller="financials--books--cards--bills--list"></div>
                  <div class="col-2 px-1" data-${this.controllerName}-target="show" data-controller="financials--books--cards--bills--show"></div>
                  <div class="col-8 pl-1" data-${this.controllerName}-target="transactions" data-controller="financials--books--cards--transactions--list
                                                                                                             financials--books--cards--transactions--adjust
                                                                                                             financials--books--cards--bills--save"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--payables--dashboard--main").contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier("financials--books--cards--bills--list").doBillList()
      controller.getControllerByIdentifier("financials--books--cards--bills--show").doNoBill()
      controller.getControllerByIdentifier("financials--books--cards--transactions--list").doIndexListHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // })

}
